/* import __COLOCATED_TEMPLATE__ from './code-evaluation-error-conversation-item.hbs'; */
/* RESPONSIBLE TEAM: team-fin-voice */
import Component from '@glimmer/component';
import type { FormattedConversationCodeEvaluationError } from '../conversation-item';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';

export interface ConversationArgs {
  conversationItem: FormattedConversationCodeEvaluationError;
}

interface Signature {
  Args: ConversationArgs;
  Element: HTMLElement;
}

export default class CodeEvaluationErrorConversationItem extends Component<Signature> {
  @tracked isExpanded = false;

  get hasInputsSnapshot() {
    let snapshot = this.args.conversationItem.inputsSnapshot;
    return snapshot && Object.keys(snapshot).length > 0;
  }

  get formattedInputsSnapshot() {
    return JSON.stringify(this.args.conversationItem.inputsSnapshot ?? {}, null, 2);
  }

  @action
  toggleExpanded() {
    this.isExpanded = !this.isExpanded;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'AiAgent::VoicePlayground::ConversationItems::CodeEvaluationErrorConversationItem': typeof CodeEvaluationErrorConversationItem;
  }
}
